import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login from './components/Login';
import BuilderApp from './components/BuilderApp';
import ClientPortal from './components/ClientPortal';
import { supabase } from './lib/supabase';
import { B, FONT } from './lib/constants';

function AppRouter() {
  const { user, profile, loading } = useAuth();
  const [clientProject, setClientProject] = useState(null);
  const [clientLoading, setClientLoading] = useState(false);

  // Check for invite token in URL
  const params = new URLSearchParams(window.location.search);
  const inviteToken = params.get('invite') || params.get('token');
  const inviteProject = params.get('project');

  // Load client's project when they log in as client
  useEffect(() => {
    if (user && profile?.role === 'client') {
      loadClientProject();
    }
  }, [user, profile]);

  const loadClientProject = async () => {
    setClientLoading(true);
    // Get project from user profile
    const { data: prof } = await supabase
      .from('user_profiles')
      .select('project_id')
      .eq('id', user.id)
      .single();

    if (prof?.project_id) {
      const { data: proj } = await supabase
        .from('projects')
        .select('*')
        .eq('id', prof.project_id)
        .single();
      if (proj) setClientProject(proj);
    }
    setClientLoading(false);
  };

  if (loading || clientLoading) return (
    <div style={{ minHeight: '100vh', background: B.black, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: FONT }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ color: B.goldlt, fontSize: 11, letterSpacing: 4, textTransform: 'uppercase' }}>Muller Homes</div>
        <div style={{ color: B.muted, fontSize: 12, marginTop: 8 }}>Loading…</div>
      </div>
    </div>
  );

  // Not logged in — show login (invite token will be handled after login)
  if (!user) return <Login inviteToken={inviteToken} inviteProject={inviteProject} />;

  if (!profile) return (
    <div style={{ minHeight: '100vh', background: B.black, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: FONT, padding: 24 }}>
      <div style={{ color: B.muted, fontSize: 14, textAlign: 'center' }}>
        Setting up your account…<br/><br/>
        <button onClick={() => window.location.reload()}
          style={{ background: B.goldlt, color: B.black, border: 'none', borderRadius: 8, padding: '10px 20px', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
          Tap to Refresh
        </button>
      </div>
    </div>
  );

  if (profile?.role === 'builder') return <BuilderApp />;
  if (profile?.role === 'client') return <ClientPortal user={user} project={clientProject} />;

  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
